export default __webpack_public_path__ + "static/media/error_circle.90d7bd83.svg";